import React from "react";

const ChevronDown = ({ className }) => {
  return (
    <svg
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70711 0.792893C10.0676 1.15338 10.0953 1.72061 9.7903 2.1129L9.70711 2.20711L5.70711 6.20711C5.34662 6.56759 4.77939 6.59532 4.3871 6.2903L4.29289 6.20711L0.292893 2.20711C-0.0976311 1.81658 -0.0976311 1.18342 0.292893 0.792893C0.653377 0.432409 1.22061 0.40468 1.6129 0.709705L1.70711 0.792893L5 4.085L8.29289 0.792893C8.65338 0.432409 9.22061 0.40468 9.6129 0.709705L9.70711 0.792893Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronDown;
